import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import VideoPlayer from '../../components/VideoPlayer';
import './index.scss';
import Control from './components/ControlModule';
import EnableComponent from '../../components/EnableComponent';
import DelayTimeRecord from './components/DelayTimeRecord';
import ThreeMonitor from '../../components/XMonitor/Monitor/ThreeMonitor';
import { useSelector } from 'react-redux';
import { LoginState, SystemState } from '../../redux/type';
import { videoDelayLimit } from '../../utils/constant';
import qs from 'qs';
import { RootState } from '../../redux/store';
import { request } from '../../fetch/core';
import WebsocketCmp from '../../components/WebsocketCmp';
import { HttpStatusCode } from '../../fetch/core/constant';
import { message } from 'antd';
import RemoteCallModal from '@/components/RemoteCallModal';
import AudioRtcPlayer from '@/components/AudioRtcPlayer';
import { Method } from '@/fetch/core/util';
import { RESOLUTION } from '@/components/Resolution';
import { useVehicleTakeoverAccess } from '@/utils/hooks/useVehicleTakeoverAccess';
import { reportSgmEvent, SgmEventType } from '@/utils/sgm';

enum Direction {
  FRONT = '前',
  LEFT = '左',
  RIGHT = '右',
  BACK = '后',
}
let monitorDiffTime = -1;

const SortableItem = ({
  pushType,
  value,
  handleRecordDelayValue,
  showResolution,
  onChangeResolution,
  index,
}: any) => (
  <li className='item'>
    <div className='remote-video'>
      {value.videoUrl ? (
        <VideoPlayer
          videoUrl={value.videoUrl}
          direction={value.direction}
          maxDelay={videoDelayLimit}
          pushType={pushType}
          handleRecordDelayValue={handleRecordDelayValue}
          showResolution={showResolution}
          onChangeResolution={onChangeResolution}
        />
      ) : (
        <div className='no-video vcbox'>NO SIGNAL</div>
      )}
    </div>
    <i className='direction'>{value.direction}</i>
  </li>
);

// eslint-disable-next-line new-cap
const SortableList = ({
  items,
  handleRecordDelayValue,
  pushType,
  onChangeResolution,
}: any) => {
  const videoItem: any = [];
  for (const [k, v] of items.entries()) {
    if (k == Direction.FRONT) {
      videoItem.push(
        <SortableItem
          key={`item-${k}`}
          value={{
            videoUrl: v,
            direction: k,
          }}
          pushType={pushType}
          handleRecordDelayValue={handleRecordDelayValue}
          showResolution={true}
          onChangeResolution={onChangeResolution}
        />,
      );
    } else {
      videoItem.push(
        <SortableItem
          key={`item-${k}`}
          value={{
            videoUrl: v,
            direction: k,
          }}
          pushType={pushType}
          handleRecordDelayValue={handleRecordDelayValue}
        />,
      );
    }
  }
  return <ul className='video-content'>{videoItem}</ul>;
};

let _ConnectionStatus = '';
const RemoteControl = () => {
  let needHistoryBack = false;
  const audioPlayerRef = useRef<any>(null);
  const monitorRef = useRef<ThreeMonitor>(null);
  const _WSClient = useRef<any>(null);
  const dispatch = useDispatch();
  const login = useSelector((state: RootState) => state.login);
  const common = useSelector((state: RootState) => state.common);
  const [pushType, setPushType] = useState('');
  const [audioRtcPlayerUrl, setAudioRtcPlayerUrl] = useState<string | null>(
    null,
  );
  const [delayRecord, setDelayRecord] = useState({
    videoDelay: new Map([
      [Direction.FRONT, 0],
      [Direction.LEFT, 0],
      [Direction.FRONT, 0],
      [Direction.BACK, 0],
    ]),
    maxVideoDelay: {
      time: 0,
      direction: '',
    },
    localViewDelay: -1,
  });
  const queryList: any = window.location.search.split('?')[1];
  const query = qs.parse(queryList);
  const vehicleName =
    typeof query.license === 'string' ? query.license.trim() : '';
  const vehicleData = common.vehicle[vehicleName] || {};
  const userName = login.user?.username;
  const admissionGranted = useVehicleTakeoverAccess(
    vehicleName,
    userName,
    'remote_control',
  );
  const [videoList, setVideoList] = useState<any>(new Map([]));
  const [loadFailedMessage, setLoadFailedMessage] = useState<any>('');
  const [remoteControlResponse, setRemoteControlResponse] = useState<any>(null);
  const [drivable, setDrivable] = useState<any>(null);
  const [visible, setVisible] = useState(false);

  const reportRemoteControlEvent = (
    type: SgmEventType,
    code: string,
    action: string,
    result: string,
    options: {
      reason?: string;
      trigger?: string;
      requestId?: string | number | null;
      cost1?: number;
      [key: string]: unknown;
    } = {},
  ) => {
    const { reason, trigger = 'system', requestId = null, cost1, ...extra } =
      options;
    reportSgmEvent({
      type,
      code,
      msg: {
        page: 'remote_control',
        vehicleName,
        action,
        trigger,
        requestId,
        result,
        reason,
        ...extra,
      },
      cost1,
    });
  };

  useEffect(() => {
    return () => {
      if (_WSClient.current) {
        reportRemoteControlEvent(
          SgmEventType.WARN,
          'monitor_remote_control_ws',
          'websocket_close',
          'closed',
          { reason: 'page_unmount' },
        );
        _WSClient.current.close();
      }
      _WSClient.current = null;
    };
  }, []);
  const fetchVideoPlayUrl = async () => {
    const res: any = await request({
      path: `/monitor/web/video/url`,
      method: Method.POST,
      body: {
        vehicleName,
      },
    });
    const data = res.data;

    if (res.code != HttpStatusCode.Success) {
      const messageContent = (
        <div>
          <b style={{ fontSize: '16px', color: 'rgb(204, 255, 0)' }}>
            错误码：{res.errorCode || res.code}视频资源获取失败，请重试!
          </b>
          <div style={{ fontSize: '14px' }}>
            <div>
              data：{data === undefined ? 'undefined' : JSON.stringify(data)}
            </div>
            <div>errorMessage：{res.message}</div>
          </div>
        </div>
      );
      setLoadFailedMessage(messageContent);
    } else {
      setPushType(data.pushType);
      const videoUrlAndDerectionMap = new Map([
        [Direction.LEFT, data.left],
        [Direction.FRONT, data.front],
        [Direction.RIGHT, data.right],
        [Direction.BACK, data.back],
      ]);
      setVideoList(videoUrlAndDerectionMap);
      setAudioRtcPlayerUrl(data.audio);
      setLoadFailedMessage('');
    }
  };

  const onChangeResolution = (value: RESOLUTION, mesFlag = true) => {
    const startedAt = Date.now();
    request({
      absoluteURL: `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}/monitor/web/video/changeMode`,
      method: Method.POST,
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
      body: {
        vehicleName: vehicleName,
        videoMode: value,
        source: 'MONITOR',
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        mesFlag && message.success('清晰度切换成功');
        if (mesFlag) {
          reportRemoteControlEvent(
            SgmEventType.INFO,
            'monitor_remote_control_function',
            'change_resolution',
            'success',
            {
              trigger: 'click',
              resolution: value,
              cost1: Date.now() - startedAt,
            },
          );
        }
      } else if (mesFlag) {
        reportRemoteControlEvent(
          SgmEventType.ERROR,
          'monitor_remote_control_function',
          'change_resolution',
          'failed',
          {
            trigger: 'click',
            resolution: value,
            reason: 'business_failed',
            cost1: Date.now() - startedAt,
          },
        );
      }
    }).catch(() => {
      if (mesFlag) {
        reportRemoteControlEvent(
          SgmEventType.ERROR,
          'monitor_remote_control_function',
          'change_resolution',
          'failed',
          {
            trigger: 'click',
            resolution: value,
            reason: 'request_error',
            cost1: Date.now() - startedAt,
          },
        );
      }
    });
  };
  useEffect(() => {
    if (admissionGranted && userName) {
      fetchVideoPlayUrl();
    }
  }, [admissionGranted, userName]);

  const handleRecordDelayValue = (
    delay: number,
    direction: Direction,
    currentTime: number,
  ) => {
    let tempDelay = -1;
    let tempDirection = '';
    if (currentTime === 0) {
      delayRecord.videoDelay.set(direction, -999);
    } else {
      delayRecord.videoDelay.set(direction, delay);
    }

    for (const [k, v] of delayRecord.videoDelay.entries()) {
      if (v > tempDelay) {
        tempDelay = v;
        tempDirection = k;
      }
    }
    setDelayRecord({
      ...delayRecord,
      videoDelay: {
        ...delayRecord.videoDelay,
      },
      maxVideoDelay: {
        time: tempDelay,
        direction: tempDirection,
      },
    });
  };

  const handleRecordDiffTime = (diffTime: number) => {
    monitorDiffTime = diffTime;
  };

  useEffect(() => {
    if (!admissionGranted) {
      return;
    }

    const timer = setInterval(() => {
      if (monitorRef.current) {
        clearInterval(timer);
        // eslint-disable-next-line new-cap
        monitorRef.current.ShowDriveMode(false);
      }
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, [admissionGranted]);

  useEffect(() => {
    if (!admissionGranted) {
      return;
    }

    const timer = setInterval(() => {
      setDelayRecord((currentDelayRecord) => ({
        ...currentDelayRecord,
        localViewDelay: monitorDiffTime,
      }));
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [admissionGranted]);

  const getDrivableDirection = () => {
    const requestData = {
      eventType: 'REMOTE_REQUEST_VEHICLE_ENV',
    };
    handleSendRemoteRequest(JSON.stringify(requestData));
  };

  useEffect(() => {
    if (
      admissionGranted &&
      _ConnectionStatus === 'OK' &&
      login.state == LoginState.LOGINED
    ) {
      getDrivableDirection();
    }
  }, [admissionGranted, login.state, _ConnectionStatus]);

  useEffect(() => {
    let timer: any = null;
    if (admissionGranted && drivable && drivable.timeStamp) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        getDrivableDirection();
      }, 3000);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [admissionGranted, drivable && drivable.timeStamp]);

  const onOpen = (wsRef: any) => {
    _WSClient.current = wsRef.current;
    _ConnectionStatus = 'OK';
    reportRemoteControlEvent(
      SgmEventType.INFO,
      'monitor_remote_control_ws',
      'websocket_connect',
      'connected',
    );
  };

  const onMessage = (data: any) => {
    if (!data) {
      return;
    }
    const res = JSON.parse(data);
    if (Object.prototype.toString.call(res) === '[object Object]') {
      const { eventType } = res;
      switch (eventType) {
        case 'REMOTE_CONTROL_SESSION_CLOSE':
          reportRemoteControlEvent(
            SgmEventType.WARN,
            'monitor_remote_control_ws',
            'server_session_close',
            'closed',
            { reason: 'server_session_close' },
          );
          if (!needHistoryBack) {
            message.error(res.message);
          }
          needHistoryBack = true;
          setTimeout(() => {
            history.go(-1);
          }, 3000);
          break;
        case 'REMOTE_REQUEST_VEHICLE_RESPONSE':
          const responseData = res.data;
          const { delayInfo } = res.data;
          if (delayInfo) {
            const supervisorModule = delayInfo.find(
              (item: any) => item.moduleName === 'supervisor',
            );
            const responseTimeStamp = Date.now();
            // 除2取单行通路的延时
            const commandDelay =
              (responseTimeStamp - supervisorModule.transitTime) / 2 / 1000;
            responseData.commandDelay = commandDelay;
            responseData.responseTimeStamp = responseTimeStamp;
            setRemoteControlResponse(responseData);
          } else {
            setRemoteControlResponse(null);
          }
          break;
        case 'REMOTE_REQUEST_VEHICLE_ENV':
          const data = res.data || {};
          data.timeStamp = Date.now();
          setDrivable(data);
          break;
        default:
          return;
      }
    }
  };

  const handleSendRemoteRequest = (requestData: any) => {
    if (
      _ConnectionStatus !== 'OK' ||
      !_WSClient.current ||
      _WSClient.current.readyState !== WebSocket.OPEN
    ) {
      return false;
    }

    try {
      _WSClient.current.send(requestData);
      return true;
    } catch {
      return false;
    }
  };

  if (!admissionGranted) {
    return null;
  }

  return (
    <div className='control-view'>
      {userName && vehicleName && (
        <WebsocketCmp
          url={
            process.env.JDX_APP_REMOTE_COMMAND_WSURL! +
            '/' +
            vehicleName +
            '?username=' +
            userName
          }
          onOpen={onOpen}
          onMessage={onMessage}
          onClose={(event: any) => {
            _ConnectionStatus = 'LOST';
            reportRemoteControlEvent(
              SgmEventType.WARN,
              'monitor_remote_control_ws',
              'websocket_close',
              'closed',
              {
                reason: 'connection_closed',
                closeCode: event?.code,
              },
            );
          }}
          maxReconnectCallBack={() => {
            message.warning('指令通道断开，请刷新页面重新连接');
            _ConnectionStatus = 'LOST';
            reportRemoteControlEvent(
              SgmEventType.ERROR,
              'monitor_remote_control_ws',
              'websocket_reconnect',
              'failed',
              { reason: 'reconnect_exhausted' },
            );
          }}
        />
      )}
      {videoList.size ? (
        <>
          <SortableList
            items={videoList}
            pushType={pushType}
            handleRecordDelayValue={handleRecordDelayValue}
            onChangeResolution={onChangeResolution}
          />
          <AudioRtcPlayer
            url={audioRtcPlayerUrl}
            ref={audioPlayerRef}
            autoPlay={true}
          ></AudioRtcPlayer>
        </>
      ) : (
        <div className='no-all-direction vcbox'>
          {loadFailedMessage || 'VIDEO OFF'}
        </div>
      )}
      <div className='map-3d'>
        <div className='monitor'>
          {login.user && (
            <ThreeMonitor
              ref={monitorRef}
              carNumber={vehicleName}
              url={process.env.JDX_APP_MONITOR_PROXY_URL + vehicleName}
              handleRecordDiffTime={handleRecordDiffTime}
            />
          )}
        </div>
      </div>
      <div className='vehicle'>
        <EnableComponent
          enable={drivable}
          vehicleName={vehicleName}
          disabled={[SystemState.OFFLINE, SystemState.CONNECTION_LOST].includes(
            vehicleData.systemState,
          )}
        />
      </div>
      <Control
        handleSendRemoteRequest={handleSendRemoteRequest}
        vehicleName={vehicleName}
        responseData={remoteControlResponse}
        maxVideoDelay={delayRecord.maxVideoDelay.time}
        localViewDelay={monitorDiffTime}
        visible={visible}
      />
      <DelayTimeRecord
        delayList={[
          {
            desc: '视频最大延时(s)',
            mark: delayRecord.maxVideoDelay.direction,
            value: delayRecord.maxVideoDelay.time,
          },
          {
            desc: '3D延时(s)',
            value: monitorDiffTime,
          },
          {
            desc: '当前指令延时(s)',
            value:
              (remoteControlResponse && remoteControlResponse.commandDelay) ||
              '--',
          },
        ]}
      />
      <div className='remote-call'>
        <RemoteCallModal
          vehicleName={vehicleName}
          disabled={remoteControlResponse && remoteControlResponse.speed !== 0}
          size='large'
          style={{
            top: '35%',
            left: '30%',
          }}
          visible={visible}
          setVisible={setVisible}
        />
      </div>
    </div>
  );
};
export default RemoteControl;
